<template>
    <div class="modal fade" id="viewAppointmentLetterPermanent">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <button @click="printAppointmentLetterPermanent()" class="float-right btn btn-sm btn-primary"><i class="fa fa-print"></i> Print</button>
              
            </div>
            <div class="modal-body" id="printAppointmentLetterPermanent">
              <!-- right column -->
              <div class="row">
                
                <div class="col-md-12">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile" v-if="seeRecord">
                      <table class="table table-condensed">
                        <thead>
                          <td width="18%"><img :src="logo" height="90" width="100%"></td>
                          <td class="text-center"><h4><strong>{{getCompanyRecord.companyName}}</strong> <br> <small>Address : {{getCompanyRecord.address}}, {{getCompanyRecord.city}}, {{getCompanyRecord.state}} - {{getCompanyRecord.pin}}
                            <br>CIN : {{getCompanyRecord.cin}}, Website - {{getCompanyRecord.url}}, Mobile No - {{getCompanyRecord.phone}}, Email ID - {{getCompanyRecord.email}}
                            </small><br><br><strong>Appointment Letter</strong></h4></td>
                          <td class="text-right" width="20%" v-if="seeRecord.user"><barcode v-bind:value="seeRecord.user.code" height="45" width="1">
                              Show this if the rendering fails.
                            </barcode>
                          </td>
                        </thead>
                      </table>
                      <hr width="100%">
                      <table class="table" v-if="seeRecord.user" >
                        <thead>
                          <td>
                            <b>
                              {{seeRecord.user.name}} <br>
                              <i>{{seeRecord.address}},</i><br> <i>{{seeRecord.city}},</i><i v-if="seeRecord.state">{{seeRecord.state.name}} -</i>  <i>{{seeRecord.pin}}</i><br>
                            </b>
                          </td>
                          <td class="text-right" v-if="seeRecord.branch">Branch: {{seeRecord.branch.name}} <br>Date: {{currDate | myDate}}</td>
                        </thead>
                      </table>
                      <p class="text-center text-bold">Subject: Letter of Appointment</p>
                      <p>Dear <b v-if="seeRecord.user">{{seeRecord.user.name}}</b></p>
                      <p>This has reference to your application and subsequent interviews you have had with {{getCompanyRecord.companyName}}. We are pleased to appoint you as  <b v-if="seeRecord.designation">{{seeRecord.designation.name}}</b> in its <i v-if="seeRecord.branch">Branch: {{seeRecord.branch.name}}</i> based at <i v-if="seeRecord.branch">{{seeRecord.branch.address}}</i>. Your employment will be governed by the following terms and conditions:</p>
                      <p class="text-bold">1.	Monthly Gross Salary</p>
                      <p>You will be paid a monthly gross salary of Rs. {{monthlygrosssalary}}/- per month.</p>
                      <p class="text-bold">2.	Working Hours</p>
                      <p>Your working hours will be 9 am to 6:30 pm as per the current company policy. The company observes a 6-day work week. </p>
                      <p class="text-bold">3.	Date of Appointment</p>
                      <p>Your date of appointment as per company records is {{seeRecord.joiningDate | myDate}}</p>
        
                      <p class="text-bold">4.	Salary Increase</p>
                      <p>Increase in your salary will be reviewed periodically as per the policy of the Company.  Increments in the salary range will be on the basis of demonstrated results and effectiveness of performance during the period of review.</p>
                      <p class="text-bold">5.	Probation Period</p>
                      <p>You will be on probation for a period of six months from the date of your appointment.   On satisfactory completion of the probation period, you will be confirmed in service. If not confirmed after six months, this order will continue to be in operation, and the probation period will stand extended automatically till further notice.</p>
                      <p class="text-bold">6.	Leave </p>
                      <p>You will be governed by the current Leave Policy of the company for permanent employees</p>
                      <p class="text-bold">7.	Travel </p>
                      <p>Whenever you are required to undertake travel on Company work, you will be reimbursed travel expenses as per Company rules.</p>
                      <p class="text-bold">8.	Responsibilities</p>
                      <p>In view of your office, you must effectively perform to ensure results.  Your performance would be reviewed as per the Company’s Performance Management System.</p>
                      <p class="text-bold">9.	Retirement Age </p>
                      <p>The normal retirement age for all employees is 60 Years</p>
                      <p class="text-bold">10.	Notice Period</p>
                      <p>While on probation, this appointment may be terminated by either side by giving seven days notice, or seven days salary in lieu of notice period.</p>
                      <p>On confirmation, this appointment may be terminated by either side by giving one months’ notice or one months’ salary in lieu of notice period.</p>
                      <p>
                          Should you resign after confirmation, the Company will have the option to accept your resignation either with immediate effect, and pay you three months’ salary in lieu of notice period or accept it effective any day up to the end of the notice period and pay you salary for the remaining period from the acceptance of resignation till the end of the notice period.  
                      </p>
                      <p class="text-bold">11.	Transfer</p>
                      <p>You will be liable to be transferred to any other department or establishment or branch or subsidiary of the Company in India or abroad.   In such a case, you will be governed by the terms and conditions of service as applicable to the new assignment.</p>
                      <p class="text-bold">12.	Other work</p>
                      <p>Your position with the Company calls for whole time employment and you will devote yourself exclusively to the business of the Company.   You will not take up any other work for remuneration (part time or otherwise) or work on advisory capacity or be interested directly or indirectly (except as shareholder or debenture holder) in any other trade or business during your employment with the Company, without written permission from the Company.</p>
                      <p class="text-bold">13.	Conflict of Interest</p>
                      <p>
                          You will not seek full time or part time job or be involved in any way with competitor’s business activities either directly or indirectly during your employment with the Company, and for a period of 12 months in the event of cessation of your employment with the Company.
                      </p>
                      <p class="text-bold">14.	Confidential Information</p>
                      <p>You will not, at any time, without the consent of the Company disclose or divulge or make public except under legal obligation, any information regarding Company’s affairs of administration or research carried out, whether the same may be confided to you or become known to you, in the course of your service or otherwise.</p>
                      <p class="text-bold">15.	Contract/Bond with Previous Employers.</p>
                      <p>It will be your personal responsibility to discharge all obligations arising out of any contract or bond with previous employers.</p>
                      <p class="text-bold">16.	On termination</p>
                      <p>On termination of this contract, you will immediately give up to the Company all correspondence, specifications, formulae, books, documents, market data, cost data, literature, drawings, effect or records, etc. belonging to the Company or relating to its business and shall not make or retain any copies of these items.</p>
                      <p class="text-bold">17.	General </p>
                      <p>
                          The above terms and conditions are based on Company Policy, Procedures and other Rules and Regulations currently applicable to the Company’s employees and are subject to amendments and adjustments from time to time.
                        Please communicate your acceptance of this appointment by signing a copy of this letter and returning it to us.
                      </p>
                      <p>We welcome you to the {{getCompanyRecord.companyName}} family and trust we will have a long and mutually rewarding association.</p>
                      <p>Yours faithfully,</p><br>
                      <p class="text-bold">Managing Director</p><br><br>
                      <p>Accepted by <b v-if="seeRecord.user">{{seeRecord.user.name}}</b></p><br><br>
                      <p>Signature of the Candidate</p>
                      <p>Date: </p>
                      <p>Location: </p>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
                
              </div>
            </div>
            <div class="modal-footer text-center">
              <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
              >
                CLOSE
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
    
</template>
<script>
import VueBarcode from 'vue-barcode'
export default {
  name: 'PropsTesting',
  data () {
    return {
      currDate: new Date()
    }
  },
  methods: {
    printAppointmentLetterPermanent () {
      // Get HTML to print from element
      const prtHtml = document.getElementById('printAppointmentLetterPermanent').innerHTML

      // Get all stylesheets HTML
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML
      }
      // Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
      WinPrint.document.write(`<!DOCTYPE html>
        <html>
          <head>
            <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
              ${stylesHtml}
              <style type="text/css">
                table th, table td { border:1px solid #000; padding:0.5em; }
              </style>
          </head>
          <body>
              ${prtHtml}
          </body>
        </html>`)

      WinPrint.document.close()
      WinPrint.focus()
      WinPrint.print()
      WinPrint.close()
    }
  },
  components: {
    'barcode': VueBarcode
  },
  props: {
    seeRecord: {},
    contracttenure: '',
    reportingmanager: '',
    consultancyfees: '',
    monthlygrosssalary: '',
    logo: '',
    getCompanyRecord: {}
  }
}
</script>



// WEBPACK FOOTER //
// AppointmentLetterPermanent.vue?2bc9c827